'use client';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@pickleballinc/ui/components/ui/breadcrumb';
import { Fragment } from 'react';

interface BreadcrumbsProps {
	categoryTitle?: string;
	categorySlug?: string;
	slug?: string;
	newsTitle?: string;
}

export function RenderBreadcrumbs({ categoryTitle, categorySlug, slug, newsTitle }: BreadcrumbsProps) {
	const breadcrumbs = [{ label: categoryTitle, href: `/${categorySlug}/1` }];

	if (isNaN(Number(slug)) && slug !== 'all' && newsTitle) {
		breadcrumbs.push({ label: newsTitle, href: `/${categorySlug}/${slug}` });
	}

	return (
		<div>
			<div className="sm:justify-left w-full p-0 px-4 sm:flex sm:pt-2">
				<Breadcrumb>
					<BreadcrumbList>
						{breadcrumbs.map((breadcrumb, index) => {
							const isLast = index === breadcrumbs.length - 1;
							return (
								<Fragment key={index}>
									{index !== 0 && <BreadcrumbSeparator />}
									<BreadcrumbItem>
										{!isLast ? (
											<BreadcrumbLink
												href={breadcrumb.href}
												className="line-clamp-1 text-sm font-semibold text-gray-500 transition-colors hover:text-foreground"
											>
												{breadcrumb.label}
											</BreadcrumbLink>
										) : (
											<div className="line-clamp-1 text-sm font-semibold text-foreground transition-colors">
												{breadcrumb.label}
											</div>
										)}
									</BreadcrumbItem>
								</Fragment>
							);
						})}
					</BreadcrumbList>
				</Breadcrumb>
			</div>
		</div>
	);
}
